module.exports = __webpack_public_path__ + "static/feature-3-f935ef2437b56c77cbbdc47237eaffa6.svg";